module.exports = __webpack_public_path__ + "img/icon_fuli@2x.5ec173db.png";